import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Local IGNTR card primitive for the homepage dashboard.
 *
 * Standalone so each dashboard widget can import it directly. Title /
 * subtitle live in the card header; the `[card-action]` selector slot is
 * for the right-hand action (link, button, etc.); default-slot content
 * is the body.
 *
 * Inline borders + arbitrary spacing values intentional — see the IGNTR
 * README §Gotchas (Bootstrap utility collisions).
 */
@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="rounded-2xl bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)] overflow-hidden"
      style="border: 1px solid #e2e8f0;"
    >
      <div class="flex items-start justify-between gap-3 px-5 pt-4 pb-2">
        <div class="min-w-0">
          <div class="text-[14px] font-semibold text-slate-900 truncate">
            {{ title }}
          </div>
          @if (sub) {
            <div class="text-[12px] text-slate-500 truncate mt-0.5">
              {{ sub }}
            </div>
          }
        </div>
        <div class="shrink-0">
          <ng-content select="[card-action]"></ng-content>
        </div>
      </div>
      <div class="px-5 pb-5">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class DashboardCardComponent {
  @Input() title = '';
  @Input() sub?: string;
}
